export default "__VITE_ASSET__2F6Ll_dT__"